<div class="dual-list g-4">
    <div class="listbox">

        <h3 *ngIf="titleLeft" class="pv-1 text-center"> {{ titleLeft }}</h3>

        <button
            type="button"
            name="addBtn"
            class="btn btn-primary btn-block personal_design_button point-right"
            (click)="addToList()"
            [disabled]="!availableFiltered.length || disabled"
        >
            {{ 'dual_list.add' | translate }}
        </button>

        <div *ngIf="filter" class="filter">
            <input
                class="form-control"
                placeholder="{{ 'groups.balance_groups.add.search' | translate }}"
                [formControl]="availableSearch"
            />
        </div>

        <div class="record-picker">
            <ul [ngStyle]="{ 'max-height': height, 'min-height': height, height }">
                <cdk-virtual-scroll-viewport [itemSize]="9"
                                             [ngStyle]="{ 'max-height': height, 'min-height': height, height }">
                    <li *cdkVirtualFor="let item of availableFiltered; templateCacheSize: 0;"
                        (click)="selectItem('available', item)"
                        [class.selected]="isItemSelected(availableSelected, item)"
                        [class.disabled]="disabled"
                    >
                        <ng-container *ngIf="item?.resource_type_id">
                            <img
                                class="item-icon"
                                [alt]="item.resource_type_id"
                                [src]="getResourceIconSrc(item.resource_type_id)"
                            />
                        </ng-container>
                        <label>{{ item.name }}</label>
                    </li>
                </cdk-virtual-scroll-viewport>
            </ul>
        </div>

        <div class="button-bar">
            <button
                type="button"
                class="btn btn-primary pull-left personal_design_button"
                (click)="selectAll('available')"
                [disabled]="disabled || isAllSelected('available')"
            >
                {{ 'dual_list.select_all' | translate }}
                <span *ngIf="availableFiltered.length" class="ml-1">
                    ({{availableFiltered.length}})
                </span>
            </button>
            <button
                type="button"
                class="btn btn-default pull-right personal_design_button"
                (click)="selectNone('available')"
                [disabled]="!isAnySelected('available')"
            >
                {{ 'dual_list.remove_selected' | translate }}
                <span *ngIf="availableSelected.length" class="ml-1">
                    ({{availableSelected.length}})
                </span>
            </button>
            <button
                *ngIf="withMainListUpload"
                type="button"
                class="btn btn-default pull-right personal_design_button"
                (click)="uploadAvailable()"
            >
                {{ 'dual_list.unload_xls' | translate }}
            </button>
        </div>
    </div>

    <div class="listbox">
        <h3 *ngIf="titleRight" class="pv-1 text-center"> {{ titleRight }}</h3>
        <button
            type="button"
            name="removeBtn"
            class="btn btn-primary btn-block personal_design_button point-left"
            (click)="removeFromList()"
            [disabled]="!confirmedFiltered.length || disabled"
        >
            {{ 'dual_list.delete' | translate }}
        </button>

        <div *ngIf="filter" class="filter">
            <input
                class="form-control"
                placeholder="{{'groups.balance_groups.add.search' | translate}}"
                [formControl]="confirmedSearch"
            />
        </div>

        <div class="record-picker">
            <ul [ngStyle]="{ 'max-height': height, 'min-height': height, height }">
                <cdk-virtual-scroll-viewport [itemSize]="9"
                                             [ngStyle]="{ 'max-height': height, 'min-height': height, height }">
                    <li *cdkVirtualFor="let item of confirmedFiltered; templateCacheSize: 0;"
                        (click)="selectItem('confirmed', item)"
                        [class.selected]="isItemSelected(confirmedSelected, item)"
                        [class.disabled]="disabled"
                    >
                        <ng-container *ngIf="item?.resource_type_id">
                            <img
                                class="item-icon"
                                [alt]="item.resource_type_id"
                                [src]="getResourceIconSrc(item.resource_type_id)"
                            />
                        </ng-container>
                        <label>{{ item.name }}</label>
                    </li>
                </cdk-virtual-scroll-viewport>
            </ul>
        </div>

        <div class="button-bar">
            <button
                type="button"
                class="btn btn-primary pull-left personal_design_button"
                (click)="selectAll('confirmed')"
                [disabled]="disabled || isAllSelected('confirmed')"
            >
                {{ 'dual_list.select_all' | translate }}
                <span *ngIf="confirmedFiltered.length" class="ml-1">
                    ({{confirmedFiltered.length}})
                </span>
            </button>
            <button
                type="button"
                class="btn btn-default pull-right personal_design_button"
                (click)="selectNone('confirmed')"
                [disabled]="!isAnySelected('confirmed')"
            >
                {{ 'dual_list.remove_selected' | translate }}
                <span *ngIf="confirmedSelected.length" class="ml-1">
                    ({{confirmedSelected.length}})
                </span>
            </button>
            <button
                *ngIf="withMainListUpload"
                type="button"
                class="btn btn-default pull-right personal_design_button"
                (click)="uploadConfirmed()"
            >
                {{ 'dual_list.unload_xls' | translate }}
            </button>
        </div>

        <ng-content select=".confirm-buttons"></ng-content>
    </div>
</div>
<div *ngIf="isLoading" class="loading-shade">
    <mat-progress-spinner color="primary"  mode="indeterminate" ></mat-progress-spinner>
</div>
